import { render, staticRenderFns } from "./TodayQuestions.vue?vue&type=template&id=738d6800&scoped=true&"
import script from "./TodayQuestions.vue?vue&type=script&lang=js&"
export * from "./TodayQuestions.vue?vue&type=script&lang=js&"
import style0 from "./TodayQuestions.vue?vue&type=style&index=0&id=738d6800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738d6800",
  null
  
)

export default component.exports